export default {"src":"https://images-cdn.curipod.com/d-77b3a0f1/_next/static/media/rocket.9360f2a3.svg","height":199,"width":200};